/**
 * Shared Card Component for Checkout Pages
 * Provides consistent card styling for checkout steps
 */

import React from 'react';

interface CheckoutCardProps {
  children: React.ReactNode;
}

export const CheckoutCard: React.FC<CheckoutCardProps> = ({ children }) => {
  return (
    <div className="bg-white/95 dark:bg-kind-graphite/95 backdrop-blur-sm rounded-2xl shadow-xl border border-gray-200 dark:border-white/10 p-6">
      {children}
    </div>
  );
};
